module.exports = __webpack_public_path__ + "img/added-list.a97cb7e6.svg";